module.exports = {
	"articleTitle1": "UM honored as first campus to receive environmental stewardship ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "U-M Golf Course",
	"articleLink1": "https://www.michigandaily.com/section/campus-life/u-m-becomes-first-university-receive-environmental-stewardship-certification",
	"articleLink2": "http://michigandaily.com/sports/thompson-finishes-third-big-ten-championships-ncaa-tournament-streak-ends-mens-golf",
	"articleSnippet1": "Jun 2, 2017 ... The University of Michigan became the first university to earn a campus-wide ... \nThe ceremony, held at the newly built University Golf Course ...",
	"articleSnippet2": "Apr 29, 2012 ... “(It) was probably one of, if not the toughest course we've played all year,” ... The \nNCAA Central Regional will be held at the U-M Golf Course ...",
	"totalMisc": 0,
	"articleTitle2": "Thompson finishes third at Big Ten Championships, NCAA ...",
	"address": "500 E Stadium Blvd, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170502/Golf.jpg?itok=I2hnOrSD",
			"author": "File Photo",
			"caption": "The Michigan men's golf team battled through injuries to earn a ninth-place result at the Big Ten Championships this weekend."
		}
	],
	"position": {
		"lat": 42.262669,
		"lng": -83.742857
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/umgolfcourse.json
// module id = 993
// module chunks = 0